import React from 'react'
import Home from '../pages/Home';
import AboutUs from '../Home/AboutUs';
import LogoSlider from '../Home/Logo';

const HomeSlider = () => {
  return (
    <div>
    <Home></Home> 
     <AboutUs/>
     <LogoSlider />
    </div>

  )
}

export default HomeSlider